// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"37":"9052afab","453":"8d7f3a60"}[chunkId] + ".chunk.js");